import { render } from "./ModalPhoto.vue?vue&type=template&id=00b073a8&scoped=true"
import script from "./ModalPhoto.vue?vue&type=script&lang=js"
export * from "./ModalPhoto.vue?vue&type=script&lang=js"

import "./ModalPhoto.vue?vue&type=style&index=0&id=00b073a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b073a8"]])

export default __exports__